/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intakenofiles2Inputs */

const en_intakenofiles2 = /** @type {(inputs: Intakenofiles2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No files yet. Drop something above, or skip to chat below.`)
};

const pt_intakenofiles2 = /** @type {(inputs: Intakenofiles2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda sem ficheiros. Largue algo acima, ou avance para o chat.`)
};

/**
* | output |
* | --- |
* | "No files yet. Drop something above, or skip to chat below." |
*
* @param {Intakenofiles2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const intakenofiles2 = /** @type {((inputs?: Intakenofiles2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intakenofiles2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_intakenofiles2(inputs)
	return pt_intakenofiles2(inputs)
});
export { intakenofiles2 as "intakeNoFiles" }